import { render } from "./KaradListReport.vue?vue&type=template&id=3b957d2e&scoped=true"
import script from "./KaradListReport.vue?vue&type=script&lang=js"
export * from "./KaradListReport.vue?vue&type=script&lang=js"

import "./KaradListReport.vue?vue&type=style&index=0&id=3b957d2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b957d2e"]])

export default __exports__